(function() {
  function move(el, target, before) {
    if (!el || !target) return;
    if (before) target.insertBefore(el, before);
    else target.appendChild(el);
  }

  function hideEmptySectionShell(section) {
    if (!section) return;
    if (section.querySelector('.product__row')) return;
    section.classList.add('tt-section-shell-hidden');
  }

  function layoutHeroFeatures() {
    var title = document.querySelector('.product__title');
    var hero = document.querySelector('.tt-hero-features');
    if (!hero || !title || hero.dataset.ttMoved === '1') return;

    var heroSection = hero.closest('.shopify-section');
    move(hero, title.parentNode, title.nextSibling);
    hero.dataset.ttMoved = '1';
    hideEmptySectionShell(heroSection);
  }



  function layoutHandbagInlineVariants() {
    if (!document.body.classList.contains('tt-handbag-product')) return false;
    if (window.innerWidth < 768) return false;

    var thumbs = document.querySelector('.gallery__thumbnails--variant-colors');
    var gallery = thumbs && thumbs.closest('.gallery, .gallery__default');
    var form = document.querySelector('#product--page') || document.querySelector('.product__page--info');
    if (!thumbs || !form) return false;

    var wrap = document.getElementById('tt-handbag-variant-picker');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'tt-handbag-variant-picker';
      wrap.className = 'tt-handbag-variant-picker';
    }

    var slotLabel = document.getElementById('tt-handbag-slot-label');
    if (!slotLabel) {
      slotLabel = document.createElement('p');
      slotLabel.id = 'tt-handbag-slot-label';
      slotLabel.className = 'tt-handbag-slot-label';
      slotLabel.hidden = true;
      wrap.insertBefore(slotLabel, wrap.firstChild);
    }

    var anchor = form.querySelector('.product__price--holder, .productPrice, [data-product-price]');
    if (!anchor) anchor = form.querySelector('.product__atc');
    if (!anchor) return false;

    if (wrap.parentNode !== form || wrap.nextSibling !== anchor) {
      form.insertBefore(wrap, anchor);
    }
    if (thumbs.parentNode !== wrap) {
      wrap.appendChild(thumbs);
    }

    if (gallery) gallery.classList.add('tt-handbag-gallery--image-only');
    document.body.classList.add('tt-handbag-inline-variants');
    recenterHandbagGallery();
    document.dispatchEvent(new CustomEvent('tt:handbag-variants-moved'));
    return true;
  }

  function recenterHandbagGallery() {
    var holder = document.querySelector(
      '.tt-handbag-gallery--image-only [data-bstr-slide-holder], ' +
      '.slider--product-holder--variant-colors[data-bstr-slide-holder], ' +
      '.slider--product-holder--variant-colors'
    );
    if (!holder) return;

    holder.scrollLeft = 0;
    holder.dataset.bstrSliderCurrent = '0';

    var firstSlide = holder.querySelector('[data-bstr-slide] img, .slide--product img');
    if (firstSlide) {
      firstSlide.style.removeProperty('opacity');
      firstSlide.style.removeProperty('visibility');
    }

    try {
      var BT = window.BoosterTheme;
      if (BT && BT.PPSlider && typeof BT.PPSlider._moveTo === 'function') {
        BT.PPSlider._moveTo({ index: 0, slider: holder });
        if (typeof BT.PPSlider._moveThumbTo === 'function') {
          BT.PPSlider._moveThumbTo({ index: 0 });
        }
      }
    } catch (e) {}
  }

  window.__ttRecenterHandbagGallery = recenterHandbagGallery;

  function isSimpleProductPage() {
    return document.documentElement.classList.contains('tt-product-tumbler') ||
      document.documentElement.classList.contains('tt-product-doll') ||
      document.documentElement.classList.contains('tt-product-straw');
  }

  function undoMobileQuickBuyLayout() {
    if (!isSimpleProductPage()) return;

    var row = document.querySelector('.product__row');
    var gallery = document.querySelector('.gallery.tt-mobile-gallery--inline, .gallery__default.tt-mobile-gallery--inline');
    if (row && gallery && gallery.dataset.ttMobileMoved === '1') {
      var info = row.querySelector('.product__page--info');
      if (info) row.insertBefore(gallery, info);
      else row.insertBefore(gallery, row.firstChild);
      gallery.classList.remove('tt-mobile-gallery--inline');
      delete gallery.dataset.ttMobileMoved;
    }

    if (row) row.classList.remove('tt-mobile-quick-buy-row');
    document.body.classList.remove('tt-mobile-quick-buy');
    delete document.body.dataset.ttMobileQuickBuyDone;
  }

  function layoutMobileQuickBuy() {
    if (document.body.classList.contains('tt-handbag-product')) return false;
    if (document.documentElement.classList.contains('tt-product-tumbler')) return false;
    if (document.documentElement.classList.contains('tt-product-doll')) return false;
    if (document.documentElement.classList.contains('tt-product-straw')) return false;
    if (window.innerWidth > 767) return false;
    if (document.body.dataset.ttMobileQuickBuyDone === '1') return true;

    var row = document.querySelector('.product__row');
    var form = document.querySelector('#product--page form, .product__page--info form');
    if (!row || !form) return false;

    var gallery = row.querySelector('.gallery.gallery__default, .gallery:not(.hide-mobile)');
    var title = form.querySelector('.product__title');
    var atc = form.querySelector('.product__atc');
    if (!gallery || !title || !atc) return false;

    if (gallery.dataset.ttMobileMoved !== '1') {
      gallery.classList.add('tt-mobile-gallery--inline');
      form.insertBefore(gallery, title.nextSibling);
      gallery.dataset.ttMobileMoved = '1';
    }

    if (atc.dataset.ttMobileMoved !== '1') {
      form.insertBefore(atc, gallery.nextSibling);
      atc.dataset.ttMobileMoved = '1';
    }

    row.classList.add('tt-mobile-quick-buy-row');
    document.body.classList.add('tt-mobile-quick-buy');
    document.body.dataset.ttMobileQuickBuyDone = '1';

    return true;
  }

  function findDollReviewsBlock(form) {
    if (!form) return null;
    var direct = form.querySelector('.jdgm-widget.jdgm-all-reviews-text, .jdgm-all-reviews-text, .jdgm-widget');
    if (direct) return direct;
    var blocks = form.querySelectorAll('.shopify-app-block');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].querySelector('.jdgm-widget, .jdgm-all-reviews-text')) return blocks[i];
    }
    return null;
  }

  function mountDollSelectorInDock(dock) {
    var selector = document.getElementById('tt-doll-selector');
    if (!selector || !dock) return;

    if (window.innerWidth > 767) {
      selector.hidden = true;
      if (selector.dataset.ttDockMounted === '1' && selector.parentNode === dock) {
        document.body.insertBefore(selector, document.getElementById('tt-chat-bubble'));
        delete selector.dataset.ttDockMounted;
      }
      return;
    }

    var atc = dock.querySelector('.product__atc');
    if (atc && selector.parentNode !== dock) {
      dock.insertBefore(selector, atc);
    } else if (atc && selector.nextElementSibling !== atc) {
      dock.insertBefore(selector, atc);
    } else if (!atc && selector.parentNode !== dock) {
      dock.insertBefore(selector, dock.firstChild);
    }

    selector.hidden = false;
    selector.dataset.ttDockMounted = '1';
  }

  function ensureDollLayoutAnchors(form) {
    if (!form) return;
    [
      { sel: '.product__title', id: 'tt-doll-title-anchor' },
      { sel: '.product__price--holder', id: 'tt-doll-price-anchor' },
      { sel: '.product__swatches', id: 'tt-doll-swatches-anchor' },
      { sel: '.product__atc', id: 'tt-doll-atc-anchor' },
      { sel: '.product__description', id: 'tt-doll-description-anchor' },
      { sel: '.product__stock', id: 'tt-doll-stock-anchor' },
      { sel: '.product__badges', id: 'tt-doll-badges-anchor' }
    ].forEach(function(item) {
      if (document.getElementById(item.id)) return;
      var el = form.querySelector(item.sel);
      if (!el) return;
      var anchor = document.createElement('span');
      anchor.id = item.id;
      anchor.hidden = true;
      anchor.setAttribute('aria-hidden', 'true');
      el.parentNode.insertBefore(anchor, el);
    });

    form.querySelectorAll('.product__urgency').forEach(function(el, index) {
      var id = 'tt-doll-urgency-anchor-' + index;
      if (document.getElementById(id)) return;
      var anchor = document.createElement('span');
      anchor.id = id;
      anchor.hidden = true;
      anchor.setAttribute('aria-hidden', 'true');
      el.parentNode.insertBefore(anchor, el);
    });
  }

  function findDollBenefitsBlock(form) {
    var dollBenefits = document.getElementById('tt-doll-benefits');
    if (dollBenefits) return dollBenefits;
    if (!form) return null;
    var blocks = form.querySelectorAll('.product__urgency');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].querySelector('ul, li')) return blocks[i];
    }
    return null;
  }

  function getDollProductMeta() {
    var el = document.getElementById('tt-doll-product-meta');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }





  function enhanceDollPriceDisplay(dock) {
    if (!dock || window.innerWidth > 767) return;
    var holder = dock.querySelector('.product__price--holder');
    if (!holder) return;

    holder.classList.add('tt-doll-price-stack');
    var meta = getDollProductMeta();
    var saleTag = holder.querySelector('.tag.tag--sale');
    var price = parseInt(meta.price, 10) || 0;
    var compareAt = parseInt(meta.compareAt, 10) || 0;

    if (compareAt > price && price > 0) {
      var pct = Math.round((compareAt - price) * 100 / compareAt);
      var saveEl = holder.querySelector('.tt-doll-save-pct');
      if (!saveEl) {
        saveEl = document.createElement('span');
        saveEl.className = 'tt-doll-save-pct';
        holder.appendChild(saveEl);
      }
      saveEl.textContent = 'Save ' + pct + '%';
      if (saleTag) saleTag.classList.add('tt-doll-save-pct--hidden');
    }

    holder.dataset.ttDollPriceEnhanced = '1';
  }



  function polishDollCheckoutDock(dock) {
    enhanceDollPriceDisplay(dock);
    if (!document.documentElement.classList.contains('tt-kpop-doll-pair')) {
      mountDollSocialProof(dock);
    }
  }

  function isKpopDollPairMobile() {
    return window.innerWidth <= 767 && document.documentElement.classList.contains('tt-kpop-doll-pair');
  }

  function getKpopDollPairData() {
    var el = document.getElementById('tt-kpop-doll-pair-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getActiveKpopDollCharacter() {
    var data = getKpopDollPairData();
    if (!data || !data.characters) return null;
    return data.characters[data.activeHandle] || null;
  }

  function formatDollMoney(cents, fallback) {
    if (fallback) return fallback;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updateDollCharacterPrice(character) {
    if (!character) return;
    var holder = document.querySelector('.tt-doll-checkout-dock .product__price--holder, .product__price--holder');
    if (!holder) return;

    var priceEl = holder.querySelector('.product__price:not(.product__price--old), .jsPrice:not(.product__price--old)');
    var compareEl = holder.querySelector('.product__price--old');
    if (priceEl) priceEl.textContent = formatDollMoney(character.price, character.priceFormatted);
    if (compareEl) {
      if (character.compareAt > character.price) {
        compareEl.textContent = formatDollMoney(character.compareAt, character.compareAtFormatted);
        compareEl.hidden = false;
        compareEl.style.display = '';
      } else {
        compareEl.hidden = true;
        compareEl.style.display = 'none';
      }
    }

    var stickyPrice = document.querySelector('.tt-sticky-bar__price');
    if (stickyPrice) stickyPrice.textContent = formatDollMoney(character.price, character.priceFormatted);

    var saveEl = holder.querySelector('.tt-doll-save-pct');
    if (character.compareAt > character.price && character.price > 0) {
      var pct = Math.round((character.compareAt - character.price) * 100 / character.compareAt);
      if (!saveEl) {
        saveEl = document.createElement('span');
        saveEl.className = 'tt-doll-save-pct';
        holder.appendChild(saveEl);
      }
      saveEl.textContent = 'Save ' + pct + '%';
    } else if (saveEl) {
      saveEl.remove();
    }
  }

  function syncDollHeroImage() {
    var character = getActiveKpopDollCharacter();
    var img = document.querySelector('.tt-doll-hero__img');
    if (!character || !img || !character.heroImage) return;
    if (img.dataset.ttActiveSrc !== character.heroImage) {
      img.dataset.ttActiveSrc = character.heroImage;
      img.src = character.heroImage;
      img.alt = character.heroAlt || character.title || '';
    }
  }

  function rebuildDollDetailGallery() {
    if (!isKpopDollPairMobile()) return;
    var character = getActiveKpopDollCharacter();
    var grid = document.querySelector('[data-tt-doll-detail-grid]');
    if (!grid || !character) return;

    grid.innerHTML = '';
    (character.detailImages || []).forEach(function(item) {
      if (!item || !item.src) return;
      var cell = document.createElement('div');
      cell.className = 'tt-doll-detail-gallery__cell';
      var img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      cell.appendChild(img);
      grid.appendChild(cell);
    });
    grid.hidden = !(character.detailImages && character.detailImages.length);
  }

  function ensureDollHeroBlock(row) {
    if (!isKpopDollPairMobile() || !row) return null;
    var hero = document.getElementById('tt-doll-hero');
    if (!hero) {
      hero = document.createElement('div');
      hero.id = 'tt-doll-hero';
      hero.className = 'tt-doll-hero';
      hero.innerHTML = '<div class="tt-doll-hero__frame"><img class="tt-doll-hero__img" alt="" width="800" height="1000" loading="eager" decoding="async"></div>';
    }
    if (hero.parentNode !== row) {
      row.insertBefore(hero, row.firstChild);
    }
    syncDollHeroImage();
    return hero;
  }

  function prepareDollDetailGallery(gallery) {
    if (!isKpopDollPairMobile() || !gallery) return gallery;
    gallery.classList.add('tt-doll-detail-gallery');

    var holder = gallery.querySelector('[data-bstr-slide-holder], .slider--product-holder, .slider--product__holder');
    if (holder) holder.classList.add('tt-doll-detail-gallery__slider-hidden');

    gallery.querySelectorAll('.gallery__thumbnails, .gallery__thumbnails--variant-colors').forEach(function(node) {
      node.hidden = true;
      node.style.display = 'none';
    });

    var grid = gallery.querySelector('[data-tt-doll-detail-grid]');
    if (!grid) {
      grid = document.createElement('div');
      grid.className = 'tt-doll-detail-gallery__grid';
      grid.setAttribute('data-tt-doll-detail-grid', '');
      gallery.appendChild(grid);
    }

    rebuildDollDetailGallery();
    return gallery;
  }

  function switchDollCharacter(handle) {
    var data = getKpopDollPairData();
    if (!data || !data.characters || !data.characters[handle] || handle === data.activeHandle) return;

    data.activeHandle = handle;
    var character = data.characters[handle];

    document.querySelectorAll('.tt-doll-selector__option').forEach(function(opt) {
      var isActive = opt.dataset.ttDollHandle === handle;
      opt.classList.toggle('is-active', isActive);
      opt.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    document.querySelectorAll('.tt-doll-checkout-dock .product__title, #product--page .product__title, .product__title').forEach(function(titleEl) {
      titleEl.textContent = character.title;
    });

    var stickyTitle = document.querySelector('.tt-sticky-bar__title');
    if (stickyTitle) stickyTitle.textContent = character.title;

    var stickyVariant = document.querySelector('.tt-sticky-bar__variant');
    if (stickyVariant) stickyVariant.textContent = character.shortName || character.title;

    updateDollCharacterPrice(character);
    syncDollHeroImage();
    rebuildDollDetailGallery();

    if (typeof window.__ttSwitchDollCharacter === 'function') {
      window.__ttSwitchDollCharacter({
        variantId: character.variantId,
        productId: character.productId,
        available: character.available,
        heroImage: character.heroImage,
        options: [character.shortName || character.title]
      });
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    history.replaceState(null, '', root.replace(/\/?$/, '/') + 'products/' + handle);
  }

  function initDollCharacterPicker() {
    if (!isKpopDollPairMobile()) return;
    document.querySelectorAll('.tt-doll-selector__option[data-tt-doll-handle]').forEach(function(btn) {
      if (btn.dataset.ttDollPickerBound === '1') return;
      btn.dataset.ttDollPickerBound = '1';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        switchDollCharacter(btn.dataset.ttDollHandle);
      });
    });
  }

  function mountDollFeaturesBeforeDescription(form, dock) {
    var features = document.getElementById('tt-doll-features');
    var description = form && form.querySelector('.product__description');
    if (!features) return;
    if (description) {
      if (features.parentNode !== form) form.insertBefore(features, description);
      else if (description.previousElementSibling !== features) {
        form.insertBefore(features, description);
      }
    } else if (dock && dock.parentNode === form) {
      if (features.parentNode !== form) form.insertBefore(features, dock.nextSibling);
    }
    features.hidden = false;
    features.dataset.ttDockMounted = '1';
  }

  function findDollShippingBlock(form) {
    if (!form) return null;
    var blocks = form.querySelectorAll('.product__urgency');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].querySelector('[data-bstr-delivery-date]')) return blocks[i];
      var text = blocks[i].textContent || '';
      if (/delivered between|business days|shipping/i.test(text) && !blocks[i].querySelector('ul')) {
        return blocks[i];
      }
    }
    return null;
  }

  function restoreDollElementToAnchor(selector, anchorId) {
    var anchor = document.getElementById(anchorId);
    if (!anchor || !anchor.parentNode) return;
    var el = document.querySelector(selector);
    if (el && el.parentNode !== anchor.parentNode) {
      anchor.parentNode.insertBefore(el, anchor.nextSibling);
    } else if (el && anchor.nextSibling !== el) {
      anchor.parentNode.insertBefore(el, anchor.nextSibling);
    }
  }

  function restoreDollDesktopLayout() {
    if (window.innerWidth <= 767) return false;
    if (!document.body.classList.contains('tt-doll-mobile-layout')) return false;

    var form = document.querySelector('#product--page form, .product__page--info form');
    if (form) {
      restoreDollElementToAnchor('.product__title', 'tt-doll-title-anchor');
      restoreDollElementToAnchor('.product__price--holder', 'tt-doll-price-anchor');
      restoreDollElementToAnchor('.product__swatches', 'tt-doll-swatches-anchor');
      restoreDollElementToAnchor('.product__atc', 'tt-doll-atc-anchor');
      restoreDollElementToAnchor('.product__description', 'tt-doll-description-anchor');
      restoreDollElementToAnchor('.product__stock', 'tt-doll-stock-anchor');
      restoreDollElementToAnchor('.product__badges', 'tt-doll-badges-anchor');

      var reviews = findDollReviewsBlock(form);
      if (reviews) {
        var title = form.querySelector('.product__title');
        if (title && title.nextElementSibling !== reviews) {
          title.parentNode.insertBefore(reviews, title.nextSibling);
        }
      }

      form.querySelectorAll('.product__urgency').forEach(function(el, index) {
        var anchor = document.getElementById('tt-doll-urgency-anchor-' + index);
        if (anchor && anchor.parentNode && el.parentNode !== anchor.parentNode) {
          anchor.parentNode.insertBefore(el, anchor.nextSibling);
        } else if (anchor && anchor.parentNode && anchor.nextSibling !== el) {
          anchor.parentNode.insertBefore(el, anchor.nextSibling);
        }
      });
    }

    var stock = document.querySelector('.product__stock');
    if (stock) stock.hidden = false;
    var badges = document.querySelector('.product__badges');
    if (badges) badges.hidden = false;
    document.querySelectorAll('.product__urgency[data-tt-doll-deferred]').forEach(function(el) {
      el.hidden = false;
      delete el.dataset.ttDollDeferred;
    });

    [
      'tt-doll-trust-row',
            'tt-doll-benefits',
      'tt-doll-urgency-line',
            'tt-doll-features',
      'tt-doll-policy-blocks'
    ].forEach(function(id) {
      var node = document.getElementById(id);
      var chat = document.getElementById('tt-chat-bubble');
      if (node && node.dataset.ttDockMounted === '1') {
        if (chat) document.body.insertBefore(node, chat);
        else document.body.appendChild(node);
        node.hidden = true;
        delete node.dataset.ttDockMounted;
      }
    });

    var selector = document.getElementById('tt-doll-selector');
    var chat = document.getElementById('tt-chat-bubble');
    if (selector && selector.dataset.ttDockMounted === '1') {
      if (chat) document.body.insertBefore(selector, chat);
      else document.body.appendChild(selector);
      selector.hidden = true;
      delete selector.dataset.ttDockMounted;
    }

    var dock = document.getElementById('tt-doll-checkout-dock');
    if (dock && dock.parentNode) dock.parentNode.removeChild(dock);

    var dollHero = document.getElementById('tt-doll-hero');
    if (dollHero && dollHero.parentNode) dollHero.parentNode.removeChild(dollHero);

    document.querySelectorAll('.gallery.tt-doll-detail-gallery').forEach(function(gallery) {
      gallery.classList.remove('tt-doll-detail-gallery');
      gallery.querySelectorAll('.tt-doll-detail-gallery__slider-hidden').forEach(function(node) {
        node.classList.remove('tt-doll-detail-gallery__slider-hidden');
      });
      gallery.querySelectorAll('.gallery__thumbnails, .gallery__thumbnails--variant-colors').forEach(function(node) {
        node.hidden = false;
        node.style.removeProperty('display');
      });
      var grid = gallery.querySelector('[data-tt-doll-detail-grid]');
      if (grid) grid.remove();
    });

    document.querySelectorAll('.tt-doll-selector__option[data-tt-doll-handle]').forEach(function(btn) {
      delete btn.dataset.ttDollPickerBound;
    });

    var faq = document.querySelector('.shopify-section:has(.tt-product-faq)');
    var policy = document.getElementById('tt-doll-policy-blocks');
    if (policy && policy.dataset.ttPolicyMoved === '1' && faq) {
      var chatBubble = document.getElementById('tt-chat-bubble');
      if (chatBubble) document.body.insertBefore(policy, chatBubble);
      else document.body.appendChild(policy);
      policy.hidden = true;
      delete policy.dataset.ttPolicyMoved;
    }

    var recommended = document.querySelector('.shopify-section:has(.product-recommendations, .product__recommended, [data-product-recommendations])');
    if (recommended && recommended.dataset.ttDollMoved === '1') {
      var reviewSection = document.querySelector('.shopify-section:has(.jdgm-review-widget, .jdgm-widget)');
      if (reviewSection && reviewSection.parentNode) {
        reviewSection.parentNode.insertBefore(recommended, reviewSection.nextSibling);
      }
      delete recommended.dataset.ttDollMoved;
    }

    var photoGallery = document.querySelector('[data-tt-dock-photo-moved="1"]');
    if (photoGallery) {
      var reviewWidget = document.querySelector('.jdgm-review-widget, .jdgm-widget[data-widget-name="review_widget"]');
      if (!reviewWidget) reviewWidget = document.querySelector('.shopify-section .jdgm-review-widget');
      if (reviewWidget) {
        var galleryAnchor = reviewWidget.querySelector('.jdgm-rev-widg__header, .jdgm-widget__header, .jdgm-rev-widg__title');
        if (galleryAnchor && galleryAnchor.parentNode) {
          galleryAnchor.parentNode.insertBefore(photoGallery, galleryAnchor.nextSibling);
        } else {
          reviewWidget.insertBefore(photoGallery, reviewWidget.firstChild);
        }
      }
      delete photoGallery.dataset.ttDockPhotoMoved;
    }

    document.body.classList.remove('tt-doll-mobile-layout');
    delete document.body.dataset.ttDollLayoutDone;
    delete document.body.dataset.ttDollPhotoWatch;
    return true;
  }

  function mountDollCheckoutStack(dock, stack) {
    if (!dock || !stack) return;
    stack.forEach(function(el) {
      if (!el) return;
      dock.appendChild(el);
      el.hidden = false;
      if (el.id === 'tt-doll-trust-row' || el.id === 'tt-doll-selector' || el.id === 'tt-doll-urgency-line') {
        el.dataset.ttDockMounted = '1';
      }
    });
  }

  function mountDollFeaturesAfterDescription(form, dock) {
    var features = document.getElementById('tt-doll-features');
    var description = form && form.querySelector('.product__description');
    if (!features) return;
    if (description) {
      if (features.parentNode !== form) form.insertBefore(features, description.nextSibling);
      else if (description.nextElementSibling !== features) {
        form.insertBefore(features, description.nextSibling);
      }
    } else if (dock && dock.parentNode === form) {
      if (features.parentNode !== form) form.insertBefore(features, dock.nextSibling);
    }
    features.hidden = false;
    features.dataset.ttDockMounted = '1';
  }

  function findDollPhotoGallery() {
    var gallery = document.querySelector('.jdgm-gallery, .jdgm-ugc-media-wrapper, .jdgm-carousel-wrapper, .jdgm-media-grid, .jdgm-rev-widg__media');
    if (!gallery) {
      var widget = document.querySelector('.jdgm-review-widget, .jdgm-widget[data-widget-name="review_widget"]');
      if (!widget) widget = document.querySelector('.shopify-section .jdgm-review-widget, .shopify-section .jdgm-rev-widg');
      if (widget) {
        gallery = widget.querySelector('.jdgm-gallery, .jdgm-ugc-media-wrapper, .jdgm-carousel-wrapper, .jdgm-media-grid, .jdgm-rev-widg__media, [class*="jdgm-gallery"], [class*="ugc-media"]');
      }
    }
    return gallery;
  }

  function layoutDollPhotoGalleryMobile() {
    if (window.innerWidth > 767) return false;
    if (!document.documentElement.classList.contains('tt-product-doll')) return false;

    var gallery = findDollPhotoGallery();
    if (!gallery || gallery.dataset.ttDockPhotoMoved === '1') return false;

    var form = document.querySelector('#product--page form, .product__page--info form');
    var description = form && form.querySelector('.product__description');
    if (!description || !description.parentNode) return false;

    description.parentNode.insertBefore(gallery, description);
    gallery.hidden = false;
    gallery.dataset.ttDockPhotoMoved = '1';
    return true;
  }

  function watchDollPhotoGallery() {
    if (window.innerWidth > 767) return;
    if (!document.documentElement.classList.contains('tt-product-doll')) return;
    if (document.body.dataset.ttDollPhotoWatch === '1') return;
    document.body.dataset.ttDollPhotoWatch = '1';

    var observer = new MutationObserver(function() {
      layoutDollPhotoGalleryMobile();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function layoutDollJudgeMePhotos() {
    return layoutDollPhotoGalleryMobile();
  }

  function layoutDollPageSections() {
    if (window.innerWidth > 767) return false;

    var faq = document.querySelector('.shopify-section:has(.tt-product-faq)');
    var policy = document.getElementById('tt-doll-policy-blocks');
    if (policy && faq && policy.dataset.ttPolicyMoved !== '1') {
      faq.appendChild(policy);
      policy.hidden = false;
      policy.dataset.ttPolicyMoved = '1';
    }

    var shipping = findDollShippingBlock(document.querySelector('#product--page form, .product__page--info form'));
    if (shipping && policy && shipping.parentNode !== policy) {
      policy.insertBefore(shipping, policy.firstChild);
      shipping.classList.add('tt-doll-shipping-block');
    }

    var recommended = document.querySelector('.shopify-section:has(.product-recommendations, .product__recommended, [data-product-recommendations])');
    if (recommended && recommended.dataset.ttDollMoved !== '1') {
      var main = document.querySelector('main');
      if (main) {
        main.appendChild(recommended);
        recommended.dataset.ttDollMoved = '1';
      }
    }

    layoutDollJudgeMePhotos();
    return true;
  }

  function ensureTumblerLayoutAnchors(form) {
    var gallery = document.querySelector('.gallery.gallery__default, .gallery:not(.hide-mobile)');
    [
      { sel: '.product__title', id: 'tt-tumbler-title-anchor', root: form },
      { sel: '.product__price--holder', id: 'tt-tumbler-price-anchor', root: form },
      { sel: '.product__swatches', id: 'tt-tumbler-swatches-anchor', root: form },
      { sel: '.product__atc', id: 'tt-tumbler-atc-anchor', root: form },
      { sel: '.gallery__thumbnails--variant-colors', id: 'tt-tumbler-variant-row-anchor', root: gallery }
    ].forEach(function(item) {
      if (document.getElementById(item.id)) return;
      if (!item.root) return;
      var el = item.root.querySelector(item.sel);
      if (!el) return;
      var anchor = document.createElement('span');
      anchor.id = item.id;
      anchor.hidden = true;
      anchor.setAttribute('aria-hidden', 'true');
      el.parentNode.insertBefore(anchor, el);
    });
  }

  function restoreTumblerDesktopLayout() {
    if (window.innerWidth <= 767) return false;
    if (!document.body.classList.contains('tt-tumbler-mobile-layout')) return false;

    var dock = document.getElementById('tt-tumbler-checkout-dock');
    var form = document.querySelector('#product--page form, .product__page--info form');
    if (!form) return false;

    [
      { sel: '.product__title', anchor: 'tt-tumbler-title-anchor' },
      { sel: '.product__price--holder', anchor: 'tt-tumbler-price-anchor' },
      { sel: '.product__swatches', anchor: 'tt-tumbler-swatches-anchor' },
      { sel: '.product__atc', anchor: 'tt-tumbler-atc-anchor' },
      { sel: '.gallery__thumbnails--variant-colors', anchor: 'tt-tumbler-variant-row-anchor' }
    ].forEach(function(item) {
      var el = dock ? dock.querySelector(item.sel) : null;
      if (!el) el = form.querySelector(item.sel);
      var anchor = document.getElementById(item.anchor);
      if (el && anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(el, anchor.nextSibling);
      }
    });

    var swatches = form.querySelector('.product__swatches');
    if (swatches) swatches.hidden = false;

    if (dock && dock.parentNode) dock.parentNode.removeChild(dock);

    document.body.classList.remove('tt-tumbler-mobile-layout');
    delete document.body.dataset.ttTumblerLayoutDone;
    return true;
  }

  function layoutTumblerMobile() {
    if (!document.documentElement.classList.contains('tt-product-tumbler')) return false;
    if (window.innerWidth > 767) {
      restoreTumblerDesktopLayout();
      return false;
    }

    if (document.body.dataset.ttTumblerLayoutDone === '1') return true;

    var row = document.querySelector('.product__row');
    var form = document.querySelector('#product--page form, .product__page--info form');
    if (!row || !form) return false;

    var gallery = row.querySelector('.gallery.gallery__default, .gallery:not(.hide-mobile)');
    var atc = form.querySelector('.product__atc');
    if (!gallery || !atc) return false;

    ensureTumblerLayoutAnchors(form);

    if (gallery.parentNode === row && row.firstElementChild !== gallery) {
      row.insertBefore(gallery, row.firstChild);
    }

    var dock = document.getElementById('tt-tumbler-checkout-dock');
    if (!dock) {
      dock = document.createElement('div');
      dock.id = 'tt-tumbler-checkout-dock';
      dock.className = 'tt-tumbler-checkout-dock';
      dock.setAttribute('aria-label', 'Purchase options');
    }
    if (dock.parentNode !== form) {
      form.insertBefore(dock, form.firstChild);
    }

    var title = form.querySelector('.product__title');
    var price = form.querySelector('.product__price--holder');
    var swatches = form.querySelector('.product__swatches');
    var variantRow = gallery.querySelector('.gallery__thumbnails--variant-colors');

    if (swatches) {
      swatches.hidden = true;
      if (swatches.parentNode === dock) {
        swatches.parentNode.removeChild(swatches);
      }
      if (swatches.parentNode !== form) {
        var swatchAnchor = document.getElementById('tt-tumbler-swatches-anchor');
        if (swatchAnchor && swatchAnchor.parentNode) {
          swatchAnchor.parentNode.insertBefore(swatches, swatchAnchor.nextSibling);
        } else {
          form.appendChild(swatches);
        }
      }
    }

    if (variantRow) variantRow.classList.add('tt-tumbler-variant-row');

    /* Mobile order: title → price → color row → quantity/ATC */
    [title, price, variantRow, atc].forEach(function(el) {
      if (el) dock.appendChild(el);
    });

    document.body.classList.add('tt-tumbler-mobile-layout');
    document.body.dataset.ttTumblerLayoutDone = '1';

    if (typeof window.__ttSyncVariant === 'function') window.__ttSyncVariant();
    var params = new URLSearchParams(window.location.search);
    var variantId = (typeof window.__ttGetActiveVariantId === 'function' && window.__ttGetActiveVariantId()) || params.get('variant');
    if (variantId) {
      var BT = window.BoosterTheme;
      if (BT && BT.PPSlider && typeof BT.PPSlider._moveTo === 'function') {
        var slide = document.querySelector('[data-bstr-slide][data-variant-id="' + variantId + '"]');
        if (slide) {
          var holder = slide.closest('[data-bstr-slide-holder]');
          var slides = holder ? holder.querySelectorAll('[data-bstr-slide]') : [];
          var idx = Array.prototype.indexOf.call(slides, slide);
          if (idx >= 0) {
            try {
              BT.PPSlider._moveTo({ index: idx, slider: holder });
              if (typeof BT.PPSlider._moveThumbTo === 'function') {
                BT.PPSlider._moveThumbTo({ index: idx });
              }
            } catch (e) {}
          }
        }
      }
    }

    return true;
  }

  function getStrawProductMeta() {
    var el = document.getElementById('tt-straw-product-meta');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }



  function formatStrawReviewCount(count) {
    return '';
  }



  function enhanceStrawPriceDisplay(details) {
    if (!details) return;
    var holder = details.querySelector('.tt-bag-card-price');
    if (!holder || holder.dataset.ttStrawPriceEnhanced === '1') return;

    holder.classList.add('tt-straw-price-stack');
    var meta = getStrawProductMeta();
    var saleEl = holder.querySelector('[data-tt-bag-price]');
    var compareEl = holder.querySelector('[data-tt-bag-compare]');
    var saveEl = holder.querySelector('[data-tt-bag-save]');
    var price = parseInt(meta.price, 10) || 0;
    var compareAt = parseInt(meta.compareAt, 10) || 0;

    if (compareAt > price && price > 0) {
      var pct = Math.round((compareAt - price) * 100 / compareAt);
      var pctEl = holder.querySelector('.tt-straw-save-pct');
      if (!pctEl) {
        pctEl = document.createElement('span');
        pctEl.className = 'tt-straw-save-pct';
        holder.appendChild(pctEl);
      }
      pctEl.textContent = 'Save ' + pct + '%';
      if (saveEl) saveEl.classList.add('tt-straw-save-pct--hidden');
    }

    if (compareEl && compareEl.textContent.trim()) {
      compareEl.dataset.ttStrawWas = '1';
    }

    holder.dataset.ttStrawPriceEnhanced = '1';
  }



  function mountStrawTrustRow(actions) {
    var trust = document.getElementById('tt-straw-trust-row');
    if (!trust) return;

    trust.hidden = false;
    trust.removeAttribute('hidden');

    // Keep the 3 trust icons full-width under the site header so they
    // can be evenly spaced across the page (not nested in the ATC column).
    var header = document.querySelector('.page__header');
    if (header && header.parentNode) {
      if (trust.previousElementSibling !== header) {
        header.parentNode.insertBefore(trust, header.nextSibling);
      }
    } else if (actions && trust.parentNode !== actions) {
      actions.appendChild(trust);
    }
    trust.dataset.ttStrawMounted = '1';
  }

  function mountStrawMainGallery(form) {
    if (!form || window.innerWidth > 767) return null;
    var row = document.querySelector('.product__row');
    var gallery = row && row.querySelector('.gallery.gallery__default, .gallery:not(.hide-mobile)');
    if (!gallery) return null;

    var bagGallery = document.querySelector('.tt-straw-cap-bag-gallery, .tt-bag-card-gallery');
    var hasBagHero = bagGallery && bagGallery.querySelector('.tt-bag-card-gallery__cell');

    if (hasBagHero) {
      gallery.classList.add('tt-straw-main-gallery', 'tt-straw-main-gallery--collapsed');
      gallery.hidden = true;
      gallery.style.display = 'none';
      return null;
    }

    gallery.classList.add('tt-straw-main-gallery');
    gallery.classList.remove('tt-straw-main-gallery--collapsed');
    gallery.hidden = false;
    gallery.style.display = '';

    if (row && gallery.parentNode === row && row.firstElementChild !== gallery) {
      row.insertBefore(gallery, row.firstChild);
    }

    var picker = document.querySelector('.tt-straw-product-picker, .tt-bag-product-picker');
    if (picker && picker.parentNode === row && gallery.nextElementSibling !== picker) {
      row.insertBefore(gallery, picker);
    }

    return gallery;
  }

  function layoutStrawPhotoGalleryMobile() {
    if (window.innerWidth > 767) return false;
    if (!document.documentElement.classList.contains('tt-product-straw')) return false;

    var gallery = findDollPhotoGallery();
    if (!gallery || gallery.dataset.ttStrawPhotoMoved === '1') return false;

    var description = document.querySelector('.product__description[data-tt-straw-desc-moved="1"], .product__description');
    if (!description || !description.parentNode) return false;

    description.parentNode.insertBefore(gallery, description);
    gallery.hidden = false;
    gallery.classList.add('tt-straw-photo-reviews');
    gallery.dataset.ttStrawPhotoMoved = '1';
    return true;
  }

  function watchStrawPhotoGallery() {
    if (window.innerWidth > 767) return;
    if (!document.documentElement.classList.contains('tt-product-straw')) return;
    if (document.body.dataset.ttStrawPhotoWatch === '1') return;
    document.body.dataset.ttStrawPhotoWatch = '1';

    var observer = new MutationObserver(function() {
      layoutStrawPhotoGalleryMobile();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function layoutStrawPageSections() {
    if (window.innerWidth > 767) return false;
    if (!document.documentElement.classList.contains('tt-product-straw')) return false;

    var main = document.querySelector('main');
    var description = document.querySelector('#product--page .product__description, .product__page--info .product__description, main .product__description');
    var faq = document.querySelector('.shopify-section:has(.tt-product-faq)');
    var reviewSection = document.querySelector('.shopify-section:has(.jdgm-review-widget, .jdgm-widget[data-widget-name="review_widget"])');
    var recommended = document.querySelector('.shopify-section:has(.product-recommendations, .product__recommended, [data-product-recommendations])');

    if (description && description.dataset.ttStrawDescMoved !== '1') {
      description.hidden = false;
      description.style.display = '';
      var anchor = faq || reviewSection;
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(description, anchor);
        description.dataset.ttStrawDescMoved = '1';
      } else if (main) {
        main.appendChild(description);
        description.dataset.ttStrawDescMoved = '1';
      }
    }

    layoutStrawPhotoGalleryMobile();

    if (recommended && description && recommended.dataset.ttStrawMoved !== '1') {
      if (description.parentNode) {
        description.parentNode.insertBefore(recommended, description.nextSibling);
        recommended.dataset.ttStrawMoved = '1';
      } else if (main) {
        main.appendChild(recommended);
        recommended.dataset.ttStrawMoved = '1';
      }
    } else if (recommended && !description && recommended.dataset.ttStrawMoved !== '1' && main) {
      if (reviewSection && reviewSection.parentNode === main) {
        main.insertBefore(recommended, reviewSection.nextSibling);
      } else {
        main.appendChild(recommended);
      }
      recommended.dataset.ttStrawMoved = '1';
    }

    return true;
  }

  function polishStrawMobileLayout(form) {
    if (!form || window.innerWidth > 767) return;
    var header = form.querySelector('.tt-straw-cap-header');
    var details = form.querySelector('.tt-straw-cap-details');
        var actions = form.querySelector('.tt-straw-cap-actions');
    enhanceStrawPriceDisplay(details);
    mountStrawTrustRow(actions);
  }



  window.__ttPolishStrawMobileLayout = polishStrawMobileLayout;
  window.__ttLayoutStrawPageSections = layoutStrawPageSections;

  function initStrawStickyBar() {
    if (window.innerWidth > 767) return;
    if (!document.documentElement.classList.contains('tt-product-straw')) return;

    var bar = document.getElementById('tt-sticky-bar');
    var actions = document.querySelector('.tt-straw-cap-actions');
    var trust = document.getElementById('tt-straw-trust-row');
    var sentinel = trust || actions;
    if (!bar || !sentinel) return;

    document.body.classList.add('tt-straw-sticky-active');

    var variantEl = bar.querySelector('.tt-sticky-bar__variant');
    if (variantEl) variantEl.hidden = true;

    var qtyEl = bar.querySelector('.tt-sticky-bar__qty');
    if (qtyEl) qtyEl.hidden = true;

    var stickyAtc = bar.querySelector('.tt-sticky-bar__atc');
    if (stickyAtc && !stickyAtc.dataset.ttStrawBound) {
      stickyAtc.dataset.ttStrawBound = '1';
      stickyAtc.removeAttribute('onclick');
      stickyAtc.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var mainAtc = document.querySelector('.tt-straw-cap-actions .tt-bag-card-atc');
        if (mainAtc && !mainAtc.disabled) mainAtc.click();
      });
    }

    function syncStickyPrice() {
      var priceEl = document.querySelector('.tt-straw-cap-details [data-tt-bag-price], .tt-bag-card-price [data-tt-bag-price]');
      var stickyPrice = bar.querySelector('.tt-sticky-bar__price');
      if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent.trim();
    }

    function syncStickyTitle() {
      var titleEl = document.querySelector('.tt-straw-cap-header .tt-bag-card-title');
      var stickyTitle = bar.querySelector('.tt-sticky-bar__title');
      if (titleEl && stickyTitle) stickyTitle.textContent = titleEl.textContent.trim();
    }

    function showBar(show) {
      if (show) {
        syncStickyPrice();
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    syncStickyPrice();
    syncStickyTitle();

    if (!document.body.dataset.ttStrawStickyObserved) {
      document.body.dataset.ttStrawStickyObserved = '1';
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          showBar(!(entries[0] && entries[0].isIntersecting));
        }, { root: null, threshold: 0 });
        observer.observe(sentinel);
      } else {
        window.addEventListener('scroll', function() {
          showBar(sentinel.getBoundingClientRect().bottom < 0);
        }, { passive: true });
      }

      var details = document.querySelector('.tt-straw-cap-details');
      if (details && typeof MutationObserver !== 'undefined') {
        new MutationObserver(syncStickyPrice).observe(details, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  function layoutStrawMobile() {
    if (!document.documentElement.classList.contains('tt-product-straw')) return false;
    if (window.innerWidth > 767) {
      document.body.classList.remove('tt-straw-mobile-layout');
      delete document.body.dataset.ttStrawLayoutDone;
      delete document.body.dataset.ttStrawPhotoWatch;
      return false;
    }

    document.body.classList.remove('tt-straw-desktop-layout');
    delete document.body.dataset.ttStrawDesktopDone;

    var row = document.querySelector('.product__row');
    var form = document.querySelector('.tt-straw-product-picker form, .tt-bag-product-picker form, .tt-bag-collection-card__form');
    mountStrawMainGallery(form);

    if (typeof window.__ttInitStrawProductLayout === 'function') {
      window.__ttInitStrawProductLayout();
    }

    if (form && typeof window.__ttPolishStrawMobileLayout === 'function') {
      window.__ttPolishStrawMobileLayout(form);
    }

    layoutStrawPageSections();
    watchStrawPhotoGallery();
    initStrawStickyBar();

    document.body.classList.add('tt-straw-mobile-layout');
    document.body.dataset.ttStrawLayoutDone = '1';
    return true;
  }

  function ensureStrawColorChooser(form, colorGallery) {
    if (!form || !colorGallery) return colorGallery;
    var wrap = document.getElementById('tt-straw-color-chooser');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'tt-straw-color-chooser';
      wrap.className = 'tt-straw-color-chooser';
      var label = document.createElement('p');
      label.className = 'tt-straw-color-chooser__label';
      label.textContent = 'Choose Color';
      wrap.appendChild(label);
    }
    if (colorGallery.parentNode !== wrap) {
      wrap.appendChild(colorGallery);
    }
    return wrap;
  }

  function polishStrawDesktopLayout(form) {
    if (!form || window.innerWidth < 768) return;
    var header = form.querySelector('.tt-straw-cap-header');
    var details = form.querySelector('.tt-straw-cap-details');
        var actions = form.querySelector('.tt-straw-cap-actions');
    enhanceStrawPriceDisplay(details);
    mountStrawTrustRow(actions);
  }

  function layoutStrawDesktop() {
    if (!document.documentElement.classList.contains('tt-product-straw')) return false;
    if (window.innerWidth < 768) {
      document.body.classList.remove('tt-straw-desktop-layout');
      delete document.body.dataset.ttStrawDesktopDone;
      return false;
    }

    document.body.classList.remove('tt-straw-mobile-layout');
    delete document.body.dataset.ttStrawLayoutDone;

    var picker = document.querySelector('.tt-straw-product-picker, .tt-bag-product-picker.tt-straw-product-picker');
    var gallery = document.querySelector('.product__row > .gallery.gallery__default, .product__row > .gallery:not(.hide-mobile)');
    if (!picker) return false;

    if (gallery) {
      gallery.classList.remove('tt-straw-main-gallery--collapsed');
      gallery.hidden = false;
      gallery.style.removeProperty('display');
    }

    if (typeof window.__ttInitStrawProductLayoutDesktop === 'function') {
      window.__ttInitStrawProductLayoutDesktop();
    }

    var form = picker.querySelector('form');
    if (form && typeof window.__ttPolishStrawDesktopLayout === 'function') {
      window.__ttPolishStrawDesktopLayout(form);
    } else if (form) {
      polishStrawDesktopLayout(form);
    }

    document.body.classList.add('tt-straw-desktop-layout');
    document.body.dataset.ttStrawDesktopDone = '1';
    return true;
  }

  window.__ttLayoutStrawDesktop = layoutStrawDesktop;
  window.__ttPolishStrawDesktopLayout = polishStrawDesktopLayout;
  window.__ttEnsureStrawColorChooser = ensureStrawColorChooser;

  function getHandbagProductMeta() {
    var el = document.getElementById('tt-handbag-product-meta');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function isBagProductHandle(handle) {
    if (!handle) return false;
    handle = String(handle).toLowerCase();
    return handle.indexOf('bag') >= 0 ||
      handle.indexOf('chest-bag') >= 0 ||
      handle.indexOf('crossbody') >= 0 ||
      handle.indexOf('handbag') >= 0 ||
      handle.indexOf('shoulder-bag') >= 0;
  }







  function hideHandbagDuplicateForm() {
    if (window.innerWidth > 767) return;
    var page = document.getElementById('product--page');
    if (!page) return;
    page.classList.add('tt-handbag-duplicate-form');
    document.body.classList.add('tt-handbag-duplicate-form');
    document.querySelectorAll('#product--page .product__swatches').forEach(function(el) {
      el.hidden = true;
      el.style.display = 'none';
    });
    document.querySelectorAll('#product--page .product__atc [data-buy-button], #product--page .shopify-payment-button').forEach(function(el) {
      el.style.display = 'none';
    });
  }

  function ensureHandbagHeroImage(card) {
    var hero = card.querySelector('.tt-handbag-hero-image');
    if (!hero) {
      hero = document.createElement('div');
      hero.className = 'tt-handbag-hero-image';
      hero.setAttribute('aria-label', 'Selected bag image');
    }

    function syncHero() {
      var selected = card.querySelector('[data-tt-bag-cell].is-selected img, [data-tt-bag-cell].is-selected .tt-bag-card-gallery__img');
      if (!selected) selected = card.querySelector('.tt-bag-card-gallery__img');
      if (!selected) return;
      hero.innerHTML = '';
      var img = document.createElement('img');
      img.src = selected.currentSrc || selected.src;
      img.alt = selected.alt || '';
      img.className = 'tt-handbag-hero-image__img';
      img.loading = 'eager';
      hero.appendChild(img);
    }

    syncHero();
    card.querySelectorAll('[data-tt-bag-cell]').forEach(function(cell) {
      if (cell.dataset.ttHandbagHeroBound === '1') return;
      cell.dataset.ttHandbagHeroBound = '1';
      cell.addEventListener('click', syncHero);
    });
    return hero;
  }

  function syncHandbagColorPickerLabel(name) {
    var label = document.querySelector('[data-tt-handbag-color-selected]');
    if (!label) return;
    if (name) {
      label.textContent = name;
      return;
    }
    var sel = document.querySelector('.tt-bag-product-picker [data-tt-bag-cell].is-selected');
    if (sel) label.textContent = sel.dataset.variantTitle || '';
  }
  window.__ttSyncHandbagColorLabel = syncHandbagColorPickerLabel;

  function prepareHandbagDockGallery(gallery) {
    if (!gallery) return null;
    gallery.classList.add('tt-handbag-full-gallery', 'tt-handbag-dock-gallery');
    gallery.hidden = false;
    gallery.style.removeProperty('display');
    var thumbs = gallery.querySelector('.gallery__thumbnails--variant-colors');
    if (thumbs) {
      thumbs.hidden = true;
      thumbs.style.display = 'none';
      thumbs.classList.add('tt-handbag-gallery-thumbs-hidden');
    }
    delete gallery.dataset.ttHandbagDeferred;
    return gallery;
  }

  function mountHandbagVariantStrip(card) {
    var gallery = card.querySelector('.tt-bag-card-gallery');
    if (!gallery) return null;

    document.body.classList.remove('tt-handbag-variant-focus');
    document.documentElement.classList.remove('tt-handbag-variant-focus');
    card.querySelectorAll('[data-tt-show-all-colors], .tt-bag-show-all-colors').forEach(function(btn) {
      btn.remove();
    });

    var wrap = document.getElementById('tt-handbag-color-picker');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'tt-handbag-color-picker';
      wrap.className = 'tt-handbag-color-picker';

      var heading = document.createElement('p');
      heading.className = 'tt-handbag-color-picker__heading';
      heading.textContent = 'Choose Color';

      var selectedLabel = document.createElement('p');
      selectedLabel.className = 'tt-handbag-color-picker__selected';
      selectedLabel.setAttribute('data-tt-handbag-color-selected', '');

      wrap.appendChild(heading);
      wrap.appendChild(selectedLabel);
    }

    gallery.classList.add('tt-handbag-variant-strip');
    if (gallery.parentNode !== wrap) wrap.appendChild(gallery);
    syncHandbagColorPickerLabel();

    card.querySelectorAll('[data-tt-bag-cell]').forEach(function(cell) {
      if (cell.dataset.ttHandbagStripBound === '1') return;
      cell.dataset.ttHandbagStripBound = '1';
      cell.addEventListener('click', function() {
        setTimeout(function() {
          syncHandbagColorPickerLabel(cell.dataset.variantTitle || '');
          if (typeof window.__ttSyncProductGallery === 'function') {
            window.__ttSyncProductGallery();
          }
          var stickyVariant = document.querySelector('.tt-sticky-bar__variant');
          if (stickyVariant) stickyVariant.textContent = cell.dataset.variantTitle || '';
        }, 0);
      });
    });

    return wrap;
  }

  function findHandbagTrustBlock() {
    return document.getElementById('tt-handbag-trust-row') ||
      document.querySelector('#product--page .product-page__badge, #product--page .product__badges');
  }

  function findHandbagBenefitsBlock() {
    return document.getElementById('tt-handbag-benefits') ||
      (function() {
        var blocks = document.querySelectorAll('#product--page .product__urgency');
        for (var i = 0; i < blocks.length; i++) {
          if (blocks[i].querySelector('ul, li')) return blocks[i];
        }
        return null;
      })();
  }

  function placeHandbagSectionAfter(anchor, node, main) {
    if (!node || !main) return anchor;
    if (anchor && anchor.parentNode === main) {
      var next = anchor.nextSibling;
      if (node.parentNode !== main || node !== next) {
        main.insertBefore(node, next);
      }
      return node;
    }
    if (node.parentNode !== main) main.appendChild(node);
    return node;
  }

  function mountHandbagDescAccordion() {
    if (window.innerWidth > 767) return;
    if (!document.body.classList.contains('tt-handbag-product')) return;

    var accordion = document.getElementById('tt-handbag-desc-accordion');
    var description = document.querySelector('#product--page .product__description');
    var faq = document.querySelector('.tt-product-faq');
    if (!accordion) return;

    var featuresSlot = accordion.querySelector('[data-tt-handbag-features]');
    var faqsSlot = accordion.querySelector('[data-tt-handbag-faqs]');

    if (featuresSlot && description && !featuresSlot.dataset.ttMounted) {
      var descContent = description.querySelector('.rte, .product__description-content') || description;
      featuresSlot.innerHTML = descContent.innerHTML || description.innerHTML;
      featuresSlot.dataset.ttMounted = '1';
    }

    if (faqsSlot && faq && !faqsSlot.dataset.ttMounted) {
      var faqItems = faq.querySelectorAll('.tt-product-faq__item');
      if (faqItems.length) {
        var wrap = document.createElement('div');
        wrap.className = 'tt-handbag-desc-accordion__faq-list';
        faqItems.forEach(function(item) {
          var clone = item.cloneNode(true);
          clone.classList.add('tt-handbag-desc-accordion__faq-item');
          wrap.appendChild(clone);
        });
        faqsSlot.appendChild(wrap);
      } else {
        faqsSlot.innerHTML = faq.innerHTML;
      }
      faqsSlot.dataset.ttMounted = '1';
    }

    accordion.hidden = false;
    if (description) description.classList.add('tt-handbag-desc-source-hidden');
    if (faq) {
      var faqSection = faq.closest('.shopify-section');
      if (faqSection) faqSection.classList.add('tt-handbag-faq-source-hidden');
    }
  }

  function findHandbagQtyBlock() {
    return document.querySelector('#product--page .product__atc .quantity--input') ||
      document.querySelector('#product--page .product__atc');
  }

  function mountHandbagCheckoutStack(dock, stack) {
    if (!dock || !stack) return;
    stack.forEach(function(el) {
      if (!el) return;
      dock.appendChild(el);
      el.hidden = false;
    });
  }

  function filterHandbagRecommendations(section) {
    if (!section) return;
    var cards = section.querySelectorAll('.card--holder, .product-card, [data-product-handle]');
    if (!cards.length) {
      cards = section.querySelectorAll('a[href*="/products/"]');
    }
    cards.forEach(function(card) {
      var handle = card.getAttribute('data-product-handle') || '';
      var link = card.tagName === 'A' ? card : card.querySelector('a[href*="/products/"]');
      if (!handle && link) {
        var match = link.href.match(/\/products\/([^/?#]+)/);
        if (match) handle = match[1];
      }
      if (handle && !isBagProductHandle(handle)) {
        var holder = card.closest('.card--holder') || card;
        if (holder && holder.parentNode) holder.parentNode.removeChild(holder);
      }
    });
  }

  function restoreHandbagDesktopLayout() {
    if (window.innerWidth <= 767) return false;
    if (!document.body.classList.contains('tt-handbag-mobile-layout')) return false;

    var page = document.getElementById('product--page');
    if (page) page.classList.remove('tt-handbag-duplicate-form');
    document.body.classList.remove('tt-handbag-duplicate-form');
    document.querySelectorAll('#product--page .product__swatches').forEach(function(el) {
      el.hidden = false;
      el.style.removeProperty('display');
    });

    var dock = document.getElementById('tt-handbag-checkout-dock');
    if (dock && dock.parentNode) dock.parentNode.removeChild(dock);

    document.body.classList.remove('tt-handbag-mobile-layout');
    document.body.classList.remove('tt-handbag-sticky-active');
    document.body.classList.remove('tt-handbag-mobile-footer-compact');
    delete document.body.dataset.ttHandbagLayoutDone;
    return true;
  }

  function layoutHandbagPageSections() {
    if (window.innerWidth > 767) return false;
    if (!document.body.classList.contains('tt-handbag-product')) return false;

    var main = document.querySelector('main');
    var accordion = document.getElementById('tt-handbag-desc-accordion');
    var reviewSection = document.querySelector('.shopify-section:has(.jdgm-review-widget, .jdgm-widget[data-widget-name="review_widget"])');
    var recommended = document.querySelector('.shopify-section:has(.product-recommendations, .product__recommended, [data-product-recommendations], #s--product-page__recommended)');
    var pinkCta = document.querySelector('.shopify-section:has(button[style*="#ff2f92"])');
    var anchor = document.querySelector('.product__row');

    mountHandbagDescAccordion();

    document.querySelectorAll('main > .gallery.tt-handbag-full-gallery, main > .gallery__default.tt-handbag-full-gallery').forEach(function(node) {
      if (!node.closest('.tt-handbag-checkout-dock')) node.remove();
    });

    if (main && anchor) {
      if (reviewSection && reviewSection.dataset.ttHandbagMoved !== '1') {
        anchor = placeHandbagSectionAfter(anchor, reviewSection, main);
        reviewSection.dataset.ttHandbagMoved = '1';
      }

      if (accordion && accordion.dataset.ttHandbagMoved !== '1') {
        anchor = placeHandbagSectionAfter(anchor, accordion, main);
        accordion.dataset.ttHandbagMoved = '1';
      }

      if (recommended && recommended.dataset.ttHandbagMoved !== '1') {
        anchor = placeHandbagSectionAfter(anchor, recommended, main);
        recommended.dataset.ttHandbagMoved = '1';
        filterHandbagRecommendations(recommended);
        var recHeading = recommended.querySelector('h2, .section__heading, [class*="heading"]');
        if (recHeading) recHeading.textContent = 'Complete Your Order';
      }
    }

    if (pinkCta) pinkCta.classList.add('tt-handbag-hide-pink-cta');
    document.body.classList.add('tt-handbag-mobile-footer-compact');
    syncHandbagJudgeMeWidget();
    return true;
  }

  function initHandbagStickyBar() {
    if (window.innerWidth > 767) return;
    if (!document.body.classList.contains('tt-handbag-product')) return;

    var bar = document.getElementById('tt-sticky-bar');
    var actions = document.querySelector('.tt-bag-product-picker .tt-straw-cap-actions, .tt-bag-product-picker .tt-bag-card-atc');
    var dock = document.getElementById('tt-handbag-checkout-dock');
    var sentinel = dock || actions;
    if (!bar || !sentinel) return;

    document.body.classList.add('tt-handbag-sticky-active');

    var stickyAtc = bar.querySelector('.tt-sticky-bar__atc');
    if (stickyAtc) {
      stickyAtc.textContent = 'Add to Cart';
      if (!stickyAtc.dataset.ttHandbagBound) {
        stickyAtc.dataset.ttHandbagBound = '1';
        stickyAtc.removeAttribute('onclick');
        stickyAtc.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var mainAtc = document.querySelector('.tt-bag-product-picker .tt-bag-card-atc');
          if (mainAtc && !mainAtc.disabled) mainAtc.click();
        });
      }
    }

    function syncStickyPrice() {
      var priceEl = document.querySelector('.tt-bag-product-picker [data-tt-bag-price]');
      var stickyPrice = bar.querySelector('.tt-sticky-bar__price');
      if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent.trim();
    }

    function syncStickyTitle() {
      var titleEl = document.querySelector('.tt-bag-product-picker .tt-bag-card-title');
      var stickyTitle = bar.querySelector('.tt-sticky-bar__title');
      if (titleEl && stickyTitle) stickyTitle.textContent = titleEl.textContent.trim();
    }

    function syncStickyVariant() {
      var nameEl = document.querySelector('.tt-bag-product-picker [data-tt-bag-selected-name]');
      var stickyVariant = bar.querySelector('.tt-sticky-bar__variant');
      if (nameEl && stickyVariant) stickyVariant.textContent = nameEl.textContent.trim();
      var shipping = bar.querySelector('.tt-sticky-bar__shipping');
      if (shipping && !shipping.dataset.ttHandbagTrust) {
        shipping.dataset.ttHandbagTrust = '1';
        shipping.innerHTML = '<span class="tt-sticky-bar__trust-item">Free Shipping</span><span class="tt-sticky-bar__trust-sep" aria-hidden="true">·</span><span class="tt-sticky-bar__trust-item">30-Day Returns</span>';
      }
    }

    function showBar(show) {
      if (show) {
        syncStickyPrice();
        syncStickyTitle();
        syncStickyVariant();
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    syncStickyPrice();
    syncStickyTitle();
    syncStickyVariant();

    if (!document.body.dataset.ttHandbagStickyObserved) {
      document.body.dataset.ttHandbagStickyObserved = '1';
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          showBar(!(entries[0] && entries[0].isIntersecting));
        }, { root: null, threshold: 0 });
        observer.observe(sentinel);
      } else {
        window.addEventListener('scroll', function() {
          showBar(sentinel.getBoundingClientRect().bottom < 0);
        }, { passive: true });
      }
    }
  }

  function layoutHandbagMobile() {
    if (!document.body.classList.contains('tt-handbag-product')) return false;
    if (!document.documentElement.classList.contains('tt-handbag-picker-active')) return false;
    if (window.innerWidth > 767) {
      restoreHandbagDesktopLayout();
      return false;
    }

    var card = document.querySelector('.tt-bag-product-picker [data-tt-bag-card]');
    var form = card && card.querySelector('form');
    if (!form) return false;

    var dock = document.getElementById('tt-handbag-checkout-dock');
    if (!dock) {
      dock = document.createElement('div');
      dock.id = 'tt-handbag-checkout-dock';
      dock.className = 'tt-handbag-checkout-dock';
      dock.setAttribute('aria-label', 'Purchase options');
    }
    if (dock.parentNode !== form) {
      form.insertBefore(dock, form.firstChild);
    }

    var cardInfo = card.querySelector('.tt-bag-card-info');
    var title = cardInfo && cardInfo.querySelector('.tt-bag-card-title');
    var reviews = cardInfo && cardInfo.querySelector('.tt-bag-card-reviews');
    var price = cardInfo && cardInfo.querySelector('.tt-bag-card-price');
    var selected = cardInfo && cardInfo.querySelector('.tt-bag-card-selected');
    var variantStrip = mountHandbagVariantStrip(card);
    var fullGallery = document.querySelector('.product__row > .gallery.gallery__default, .product__row > .gallery:not(.hide-mobile)');
    fullGallery = prepareHandbagDockGallery(fullGallery);
    var qtyBlock = findHandbagQtyBlock();
    var actions = card.querySelector('.tt-straw-cap-actions');
    var trust = findHandbagTrustBlock();
    var benefits = findHandbagBenefitsBlock();

    if (selected) selected.hidden = true;

    mountHandbagCheckoutStack(dock, [
      title,
      price,
      variantStrip,
      qtyBlock,
      fullGallery,
      actions,
      trust,
      benefits
    ]);
    hideHandbagDuplicateForm();

    layoutHandbagPageSections();
    initHandbagStickyBar();

    document.body.classList.add('tt-handbag-mobile-layout');
    document.body.dataset.ttHandbagLayoutDone = '1';
    return true;
  }

  window.__ttLayoutHandbagMobile = layoutHandbagMobile;
  window.__ttLayoutHandbagPageSections = layoutHandbagPageSections;

  function layoutDollMobile() {
    if (!document.documentElement.classList.contains('tt-product-doll')) return false;
    if (window.innerWidth > 767) {
      restoreDollDesktopLayout();
      return false;
    }

    var row = document.querySelector('.product__row');
    var form = document.querySelector('#product--page form, .product__page--info form');
    if (!row || !form) return false;

    var gallery = row.querySelector('.gallery.gallery__default, .gallery:not(.hide-mobile)');
    var title = form.querySelector('.product__title');
    var price = form.querySelector('.product__price--holder');
    var swatches = form.querySelector('.product__swatches');
    var atc = form.querySelector('.product__atc');
    if (!gallery || !title || !price || !atc) return false;

    ensureDollLayoutAnchors(form);

    if (gallery.parentNode === row && row.firstElementChild !== gallery) {
      row.insertBefore(gallery, row.firstChild);
    }

    var dock = document.getElementById('tt-doll-checkout-dock');
    if (!dock) {
      dock = document.createElement('div');
      dock.id = 'tt-doll-checkout-dock';
      dock.className = 'tt-doll-checkout-dock';
      dock.setAttribute('aria-label', 'Purchase options');
    }
    if (dock.parentNode !== form) {
      form.insertBefore(dock, form.firstChild);
    }

    var isKpopPair = document.documentElement.classList.contains('tt-kpop-doll-pair');
    var reviews = findDollReviewsBlock(form);
    var benefits = findDollBenefitsBlock(form);
    var shipping = findDollShippingBlock(form);
    var stock = form.querySelector('.product__stock');
    var badges = form.querySelector('.product__badges');
    var description = form.querySelector('.product__description');
    var selector = document.getElementById('tt-doll-selector');
    var trust = document.getElementById('tt-doll-trust-row');
    var urgencyLine = document.getElementById('tt-doll-urgency-line');

    if (isKpopPair) {
      ensureDollHeroBlock(row);
      prepareDollDetailGallery(gallery);
      if (gallery.parentNode === row && gallery.previousElementSibling && gallery.previousElementSibling.id !== 'tt-doll-hero') {
        var heroNode = document.getElementById('tt-doll-hero');
        if (heroNode) row.insertBefore(gallery, heroNode.nextSibling);
      }
    }

    /* K-Pop mobile stack: title → reviews → price → character → ATC/buy → trust */
    var checkoutStack = isKpopPair
      ? [title, reviews, price, selector, atc, trust]
      : [title, reviews, price, benefits, urgencyLine, selector, swatches, atc, trust];
    mountDollCheckoutStack(dock, checkoutStack);

    if (isKpopPair && swatches) {
      swatches.hidden = true;
      swatches.style.display = 'none';
    }

    if (description) {
      if (description.parentNode !== form) form.appendChild(description);
      else if (dock.nextSibling !== description) {
        form.insertBefore(description, dock.nextSibling);
      }
    }

    if (isKpopPair) {
      mountDollFeaturesBeforeDescription(form, dock);
    } else {
      mountDollFeaturesAfterDescription(form, dock);
    }

    if (stock) stock.hidden = true;
    if (badges) badges.hidden = true;
    if (shipping && shipping.parentNode === dock) {
      /* shipping moves to policy block via layoutDollPageSections */
    } else if (shipping && shipping.dataset.ttDollDeferred !== '1') {
      shipping.hidden = true;
      shipping.dataset.ttDollDeferred = '1';
    }

    layoutDollPageSections();
    layoutDollPhotoGalleryMobile();
    watchDollPhotoGallery();
    polishDollCheckoutDock(dock);

    document.body.classList.add('tt-doll-mobile-layout');
    document.body.dataset.ttDollLayoutDone = '1';

    if (typeof window.__ttSyncDollCheckoutToForm === 'function') window.__ttSyncDollCheckoutToForm();
    if (typeof window.__ttInitDollProductPage === 'function') window.__ttInitDollProductPage();
    initDollCharacterPicker();

    return true;
  }

  function runLayout() {
    layoutHeroFeatures();
    layoutHandbagInlineVariants();
    layoutHandbagMobile();
    layoutHandbagPageSections();
    undoMobileQuickBuyLayout();
    layoutMobileQuickBuy();
    undoMobileQuickBuyLayout();
    restoreTumblerDesktopLayout();
    layoutTumblerMobile();
    layoutStrawMobile();
    layoutStrawDesktop();
    layoutDollMobile();
    layoutDollPageSections();
    layoutStrawPageSections();
    if (window.innerWidth >= 768 || document.body.classList.contains('tt-handbag-inline-variants')) {
      recenterHandbagGallery();
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    runLayout();
    if (window.innerWidth <= 767 && document.documentElement.classList.contains('tt-product-tumbler')) {
      setTimeout(layoutTumblerMobile, 400);
    }
    if (window.innerWidth <= 767 && document.documentElement.classList.contains('tt-product-straw')) {
      [120, 400, 900, 1800].forEach(function(ms) {
        setTimeout(function() {
          if (typeof window.__ttInitStrawProductLayout === 'function') {
            window.__ttInitStrawProductLayout();
          } else {
            layoutStrawMobile();
          }
          layoutStrawPageSections();
          var strawForm = document.querySelector('.tt-straw-product-picker form, .tt-bag-product-picker form');
          if (strawForm && typeof window.__ttPolishStrawMobileLayout === 'function') {
            window.__ttPolishStrawMobileLayout(strawForm);
          }
        }, ms);
      });
    }
    if (window.innerWidth <= 767 && document.body.classList.contains('tt-handbag-product')) {
      [120, 400, 900, 1800].forEach(function(ms) {
        setTimeout(function() {
          layoutHandbagMobile();
          layoutHandbagPageSections();
          initHandbagStickyBar();
        }, ms);
      });
    }
    if (window.innerWidth <= 767 && document.documentElement.classList.contains('tt-product-doll')) {
      [120, 400, 900, 1800, 3200, 5000, 8000].forEach(function(ms) {
        setTimeout(function() {
          layoutDollMobile();
          layoutDollPageSections();
        }, ms);
      });
    }
    if (window.innerWidth >= 768) {
      [150, 400, 900].forEach(function(ms) {
        setTimeout(function() {
          runLayout();
          if (document.documentElement.classList.contains('tt-product-straw')) {
            if (typeof window.__ttInitStrawProductLayoutDesktop === 'function') {
              window.__ttInitStrawProductLayoutDesktop();
            }
            layoutStrawDesktop();
          }
        }, ms);
      });
    }
  });

  window.addEventListener('resize', function() {
    if (window.innerWidth >= 768) {
      layoutHandbagInlineVariants();
      restoreHandbagDesktopLayout();
      restoreTumblerDesktopLayout();
      restoreDollDesktopLayout();
      layoutStrawDesktop();
    } else {
      document.body.classList.remove('tt-straw-desktop-layout');
      delete document.body.dataset.ttStrawDesktopDone;
      layoutHandbagMobile();
      layoutHandbagPageSections();
      layoutTumblerMobile();
      layoutStrawMobile();
      layoutStrawPageSections();
      layoutDollMobile();
    }
  });

  document.addEventListener('booster:initialized', function() {
    undoMobileQuickBuyLayout();
    layoutMobileQuickBuy();
    undoMobileQuickBuyLayout();
    restoreTumblerDesktopLayout();
    layoutTumblerMobile();
    layoutStrawMobile();
    layoutStrawDesktop();
    layoutHandbagMobile();
    layoutHandbagPageSections();
    layoutDollMobile();
    layoutDollPageSections();
    layoutStrawPageSections();

    if (document.body.classList.contains('tt-handbag-product')) {
      initHandbagStickyBar();
      [200, 700, 1400, 2800].forEach(function(ms) {
        setTimeout(function() {
          layoutHandbagMobile();
          layoutHandbagPageSections();
          initHandbagStickyBar();
          syncHandbagJudgeMeWidget();
        }, ms);
      });
      return;
    }

    if (document.documentElement.classList.contains('tt-product-tumbler')) {
      setTimeout(layoutTumblerMobile, 300);
      return;
    }

    if (document.documentElement.classList.contains('tt-product-straw')) {
      if (window.innerWidth <= 767) {
        initStrawStickyBar();
        [200, 700, 1400, 2800].forEach(function(ms) {
          setTimeout(function() {
            layoutStrawMobile();
            layoutStrawPageSections();
            initStrawStickyBar();
          }, ms);
        });
      } else {
        [200, 700, 1400, 2800].forEach(function(ms) {
          setTimeout(function() {
            if (typeof window.__ttInitStrawProductLayoutDesktop === 'function') {
              window.__ttInitStrawProductLayoutDesktop();
            }
            layoutStrawDesktop();
          }, ms);
        });
      }
      return;
    }

    if (document.documentElement.classList.contains('tt-product-doll')) {
      [200, 700, 1400, 2800, 5000, 8000].forEach(function(ms) {
        setTimeout(function() {
          layoutDollMobile();
          layoutDollPageSections();
        }, ms);
      });
      return;
    }

    var bar = document.getElementById('tt-sticky-bar');
    var atc = document.querySelector('.product__atc');
    if (!bar || !atc) return;

    function toggleBar() {
      if (atc.getBoundingClientRect().bottom < 0) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    window.addEventListener('scroll', toggleBar, { passive: true });
    toggleBar();
  });
})();
